import React, { useEffect, useState } from 'react';
import {
  UserOutlined,
  MenuUnfoldOutlined,
  WalletOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  ProductOutlined,
  GiftOutlined,
  HeartOutlined,
  GatewayOutlined,
  AuditOutlined,
  SettingOutlined,
  TagOutlined,
  GroupOutlined,
  PayCircleOutlined,
  PrinterOutlined,
  HomeOutlined,
  UsergroupAddOutlined,
  HddOutlined,
  BarChartOutlined,
  CrownOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu, theme } from 'antd';
import PageRoutes from "./PageRoutes"
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "contexts/auth"

const { Header, Sider, Content } = Layout;

const allMenu = [
  {
    key: '/dashboard',
    icon: <HomeOutlined />,
    label: 'Tổng quan',
    permission: "",
  },
  {
    key: '/workspace',
    icon: <FileTextOutlined />,
    label: 'Shop',
    permission: "order.all",
  },
  {
    key: '/packages',
    icon: <CrownOutlined />,
    label: 'Gói cước',
    permission: '',
  },

]

const AppMenu = ({ onMenuClick }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState([])
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {

    var items = [...allMenu];
    setMenuItems(items);

  }, [user])

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const menuClick = (e) => {

    navigate(e.key);
    onMenuClick?.(e);
  }

  return (

    <Menu
      theme="dark"
      mode="inline"
      onClick={menuClick}
      selectedKeys={[location.pathname]}
      items={menuItems}
    />

  );
};

export default AppMenu;